<div *ngIf="hasPlinks; else noPlinks">
	<div *ngFor="let modelType of plinksListing | keys" class="col-md-12 boxs3">
		<div class="panel panel-default">
			<div class="panel-heading"><strong>{{modelType}} Devices</strong></div>
		</div>
		<div *ngFor="let plink of plinksListing[modelType]; let idx = index">
			<div class="row" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx]">
				<div class="col-md-2" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx]">
					<ng-container *ngTemplateOutlet="plinkItem;context:{plink: plinksListing[modelType][idx]}" ></ng-container>
				</div>
				<div class="col-md-2" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx+1]">
					<ng-container *ngTemplateOutlet="plinkItem;context:{plink: plinksListing[modelType][idx+1]}" ></ng-container>
				</div>
				<div class="col-md-2" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx+2]">
					<ng-container *ngTemplateOutlet="plinkItem;context:{plink: plinksListing[modelType][idx+2]}" ></ng-container>
				</div>
				<div class="col-md-2" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx+3]">
					<ng-container *ngTemplateOutlet="plinkItem;context:{plink: plinksListing[modelType][idx+3]}" ></ng-container>
				</div>
				<div class="col-md-2" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx+4]">
					<ng-container *ngTemplateOutlet="plinkItem;context:{plink: plinksListing[modelType][idx+4]}" ></ng-container>
				</div>
				<div class="col-md-2" *ngIf="(idx % 6) == 0 && plinksListing[modelType][idx+5]">
					<ng-container *ngTemplateOutlet="plinkItem;context:{plink: plinksListing[modelType][idx+5]}" ></ng-container>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #plinkItem let-plink="plink">
	<div *ngIf="plink.isShow" class="panel panel-default margin-bottom-xs" style="min-height: 200px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
		<div class="top-layer">
			<div class="side-width"></div>
			<label class="checkbox tcenter p-b-5" for="{{plink.deviceid}}">
				<input type="checkbox" [(ngModel)]="plink.selected" name="group" (ngModelChange)="deviceChecked(plink, $event)" />
			</label>
			<div class="side-width"><img [src]="plink.connectionType" alt="Connection Type" width="28" height="28"></div>
		</div>
		<div class="text-center margin-top-lg">
			<div class="btn-group pointer" appDropdown>
				<a type="button" style="display: inline-block;">
					<div [ngClass]="plink.imageClass"></div>
				</a>
				<ul class="z-index-10k dropdown-menu" role="menu">
					<li><a [routerLink]="['/', customerId, siteId, 'plinks', 'settings', plink.deviceid]">Settings</a></li>
					<li><a [routerLink]="['/', customerId, siteId, 'plinks', 'quick-view', plink.deviceid]">QuickView</a></li>
					<li><a [routerLink]="['/', customerId, siteId, 'plinks', 'plink-events', plink.deviceid]">PolarLink Events</a></li>
					<li *ngIf="!currentUser.isEndClient"><a [routerLink]="['/', customerId, siteId, 'plinks', 'rt-records', plink.deviceid]">RT Records</a></li>
					<li><a [routerLink]="['/', customerId, siteId, 'plinks', 'analytics', 'faults', plink.deviceid]">Faults</a></li>
					<li *ngIf="userService.hasAccessFunction('restart_devices')">
						<a (click)="restartPolarlinkDevice(plink.deviceid)" class="has-action">Restart Polarlink</a>
					</li>
					<li><a [routerLink]="['/', customerId, siteId, 'plinks', 'notes', plink.deviceid]">Notes</a></li>
					<!-- Hidden legacy items as requested
					<li *ngIf="userService.hasAccessFunction('access_debug_records')">
						<a [routerLink]="['/', customerId, siteId, 'plinks', 'debug-records']" [queryParams]="{plinksIDs: plink.id}">Debug Records</a>
					</li>
					<li *ngIf="userService.hasAccessFunction('act_admin_device_management')">
						<a [routerLink]="['/', customerId, siteId, 'plinks', 'connectivity-track']" [queryParams]="{plinksIDs: plink.id}">Connectivity Track</a>
					</li>
					-->
				</ul>
			</div>
		</div>
		<div class="text-center margin-top-sm">
			<div>
				<span *ngIf="plink.connectivityStatus" class="label" [ngClass]="{'label-success': plink.connectivityStatus == 'Active','label-updated': plink.connectivityStatus == 'Updated' ,'label-danger': plink.connectivityStatus == 'Offline', 'label-warning': plink.connectivityStatus == 'Disabled'}">
					{{plink.connectivityStatus}}
				</span>
			</div>
			<p class="sm-font tcenter margin-top-sm"><strong>ID:</strong> {{plink.id}}</p>
			<p class="sm-font tcenter">{{plink.serialnumber}}</p>
			<p class="sm-font tcenter" *ngIf="plink.actviewenabled && plink.lastconnecttime">
				<strong>Last Connect:</strong><br/>{{plink.lastconnecttime | date:'short'}}
			</p>
		</div>
		<div class="text-center" *ngIf="plink.tags && plink.tags.length">
			<div class="btn-group p-5">
				<div class="listing-tags" *ngFor="let tag of plink.tags">
					<button class="btn btn-sm ng-binding" [ngClass]="{'btn-danger': tag.sharingoption == 'private', 'btn-info': tag.sharingoption == 'group', 'btn-default': tag.sharingoption == 'public', 'replacement-tag': tag.keep_in_replacement && currentUser.isACTuser}">
					{{tag.tagname}}
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #noPlinks>
	<div class="panel panel-default">
		<div class="panel-body">
			<strong>No PolarLink Devices Registered!</strong>
		</div>
	</div>
</ng-template>
